import React from 'react';
import '../CSS/Profile/BriannaDouglasProfile.css';

const BriannaDouglasProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/brianna-douglas-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Brianna Douglas"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Brianna Douglas, PhD</h1>
        <div className="profile-title-container">
          <p className="profile-title">Vice President and Consultant</p>
          <a href="https://www.linkedin.com/in/bbdhartsvillesc/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Brianna Douglas brings over a decade of leadership experience to her role as an executive search consultant at Myers McRae. Over her career, she has held roles in Advancement, Business and Finance, Athletics, and Student Affairs. Ms. Douglas' in-depth knowledge joined with Myers McRae's four decades of executive search expertise creates an ideal combination to successfully assist clients in recruiting outstanding candidates for their organizations.
          </p>
          <p>
            Prior to executive search consulting, Ms. Douglas held several cabinet-level positions at Coker University: Vice President of Administration, Vice President of Student Affairs, and Associate Vice President of Advancement. She is an attentive, approachable, and perceptive leader who builds strong relationships with both clients and candidates.
          </p>
          <p>
            Ms. Douglas holds a Bachelor of Arts in Psychology from Coker University and an MBA from the University of North Florida. She has recently completed her Ph.D. at the School of Education at Colorado State University.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BriannaDouglasProfile;

